import { defineComponent } from 'vue';

export default defineComponent({
    methods: {
        getListElement(): HTMLElement | null {
            return this.$el as HTMLElement | null;
        },
        updateFilter(event: Event): void {
            const vacancyList = this.getListElement();
            const select = event.target as HTMLSelectElement | null;

            if (!vacancyList || !select || !select.name) return;

            const urlParams = new URLSearchParams(window.location.search);

            if (select.value) {
                urlParams.set(select.name, select.value);
            } else {
                urlParams.delete(select.name);
            }

            window.location.href = `?${urlParams.toString()}`;
        },
    },
});
